<template>
  <div class="status">
    <data-table
      v-if="apps"
      header-text="Status"
      header-icon="nav-status-purple"
      :headers="fields"
      :table-search="false"
      :items="getAppStatuses"
      :loaded="loaded"
    >
      <template v-slot:[`item.running`]="{ item }">
        <div style="text-align: center">
          <status-indicator
            v-show="item.running"
            status="positive"
            pulse
          ></status-indicator>

          <status-indicator
            v-show="!item.running"
            status="intermediary"
          ></status-indicator>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import request from "@/API/";
import { mapState } from "vuex";
import { StatusIndicator } from "vue-status-indicator";

const compare = function (a, b) {
  const stepA = a.org_name.toUpperCase();
  const stepB = b.org_name.toUpperCase();

  let comparison = 0;
  if (stepA > stepB) {
    comparison = 1;
  } else if (stepA < stepB) {
    comparison = -1;
  }
  return comparison;
};

export default {
  name: "StatusPage",
  data: () => ({
    search: "",
    fields: [
      {
        value: "org_name",
        text: "Organisation name",
      },
      {
        value: "real_name",
        text: "App name",
      },
      {
        value: "running",
        text: "Status",
        width: "4.5%",
      },
      {
        value: "last_seen",
        text: "Last Seen",
        width: "20%",
      },
    ],
    dateFormat: "YYYY D MMM HH:mm",
    appStatuses: [],
    loaded: false,
  }),
  components: {
    DataTable: () => import("@/components/DataTable/DataTable.vue"),
    StatusIndicator,
  },
  computed: {
    ...mapState({
      apps: (state) => {
        return state.apps.apps;
      },
    }),
    getAppStatuses() {
      return this.appStatuses;
    },
  },
  methods: {
    async getStatuses() {
      this.appStatuses.length = 0;
      this.apps.map((app) => {
        request
          .get("/ingest/list/" + app.appID)
          .then((res) => {
            app.running = Object.entries(res.data).length === 0 ? false : true;
            app.last_seen =
              Object.entries(res.data).length !== 0
                ? Object.entries(res.data)[0][1].t
                : "-";
            this.appStatuses.push(app);
            this.appStatuses.sort(compare);
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      vm.clientHash = "*";
      await vm.$store.dispatch("getApps", {
        c: "*",
        q: "",
      });
      await vm.getStatuses();
      vm.loaded = true;
    });
  },
};
</script>

<style lang="scss" scoped>
  .status {
    color: var(--apio-shade-2);
    margin-top: 8px;
  }
</style>